import { create } from "zustand";

type DashboardState = {
    cardsPartner: any[];
    setCardsPartner: (value: any) => void;
    
    cardsCustomer: any[];
    setCardsCustomer: (value: any) => void;

    dataCount: any;
    setDataCount: (value: any) => void;

    requestsInfo: any[];
    setRequestsInfo: (value: any) => void;

    relaunchsInfo: any[];
    setRelaunchsInfo: (value: any) => void;

    followMissions: any[];
    setFollowMissions: (value: any) => void;
};

export const useDashboardStore = create<DashboardState>((set) => ({
    cardsPartner: [],
    setCardsPartner: (value: any) => set({ cardsPartner: value }),

    cardsCustomer: [],
    setCardsCustomer: (value: any) => set({ cardsCustomer: value }),

    dataCount: {},
    setDataCount: (value: any) => set({ dataCount: value }),

    requestsInfo: [],
    setRequestsInfo: (value: any) => set({ requestsInfo: value }),

    relaunchsInfo: [],
    setRelaunchsInfo: (value: any) => set({ relaunchsInfo: value }),

    followMissions: [],
    setFollowMissions: (value: any) => set({ followMissions: value }),
}));